import { Injectable } from '@angular/core';
import { TesService } from './tes.service';
import { ComputesitesService } from './computesites.service';
import { AuthorisationService } from './authorisation.service';
import { Job } from './job';
import { Identity } from './identity';
import { Subscription, interval, pipe, Observable, throwError, of, ReplaySubject } from 'rxjs';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { repeatWhen, delay, tap, catchError, takeUntil, startWith, switchMap } from 'rxjs/operators';
import { NotificationsService } from './notifications.service';


@Injectable({
  providedIn: 'root'
})
export class JobsService {
  public jobs$: BehaviorSubject<Job[]>;
  private tsub: Subscription;
  private id: Identity;
  private cancelRequests$: Subject<boolean>;


  constructor(private tesService: TesService, private authService: AuthorisationService, private notifications: NotificationsService ) { 
    this.jobs$ = new BehaviorSubject([]);
    this.cancelRequests$ = new Subject<boolean>();
  }

  public setId(id: Identity) {
    this.id = id;
    this.cancelRequests$.next(true);
    this.refreshJobs()
  }

  public cancelJobList() {
    this.cancelRequests$.next(true);
  }

  public refreshJobs() {
    if (this.id !== undefined && this.id !== null) {
      this.executeJobRefresh();
    }
  }

  private executeJobRefresh() {
    timer(0)
      .pipe(
        tap(() => console.log('Refreshing jobs for', this.id.site.name)),
        takeUntil(this.cancelRequests$),
        switchMap(() => 
          this.tesService.runCommand(this.id, this.id.site.statcmd).pipe(
            tap(() => console.log('Command executed:', this.id.site.statcmd)),
            tap((v) => console.log('Command response:', v)),
            catchError((err) => {
              console.log('First catchError - Raw error object:', err);
              console.log('Error type:', typeof err);
              console.log('Error constructor:', err.constructor.name);
              console.log('Error has status property:', err.hasOwnProperty('status'));
              console.log('Error status value:', err.status);
              console.log('Error message:', err.message);
              // For network errors, cancel everything and don't continue
              this.cancelRequests$.next(true);
              return throwError(err);
            }),
            catchError((err) => {
              // For other errors, also cancel everything
              this.cancelRequests$.next(true);
              return this.getJobsErrorHandler(err, this.id.site.statcmd, this.id);
            })
          )
        ),
        tap((jobs) => {
          console.log('Received jobs:', jobs);
        })
      )
      .subscribe({
        next: (qjobs) => {
          console.log('Jobs received successfully:', qjobs);
          this.jobs$.next(<Job[]>qjobs);
          // Schedule the next execution 5 seconds after this one completes
          timer(5000)
            .pipe(takeUntil(this.cancelRequests$))
            .subscribe(() => this.executeJobRefresh());
        },
        error: (error) => {
          console.log('Subscription error handler called:', error);
          this.getJobsError(error, this.id);
          // Don't schedule next execution on error
        },
        complete: () => {
          console.log('Job list refresh completed (observable completed)');
        }
      });
  }

  public networkError(error): Observable<any> {
    console.error('Network error occurred:', error);
    if (error.hasOwnProperty('status') && error.status == 0) {
      this.notifications.notify("A network error occurred. Are you connected to the internet?")
      this.cancelRequests$.next(true);
    } 
    return throwError(error);
  }

  public getJobsErrorHandler(error, cmd: string, identity: Identity): Observable<any> {
    console.error('Error in getJobsErrorHandler:', error);
    var emsg: string = "";
    if (error.hasOwnProperty('error') && error.error.hasOwnProperty('message') ) {
      emsg = error.error.message;
    } else {
      emsg = error.message;
    }
    if (identity.expiry < Date.now() && (error.hasOwnProperty("status") && error.status == 401)) {
      console.error('login expired while refreshing job list expiry',identity.expiry,'current time',Date.now() );
      this.cancelRequests$.next(true);
      this.notifications.notify("Your login has expired. Please log in again",   () => { this.authService.refresh() }  );
      return throwError(error);
    }
    if ((error.hasOwnProperty("status") && error.status == 401)) {
      this.cancelRequests$.next(true);
      this.notifications.notify("Your login has expired. Please log in again",   () => { this.authService.refresh() }  );
      return throwError(error);
    }
  
    if (error.hasOwnProperty("status") && (error.status == 503 || error.status == 500)) {
      //this.notifications.notify("The Strudel2 API server had an error.\n Please report this via the contact us link.\nThe error message was"+emsg);
      this.notifications.notify("Unable to retrieve a list of jobs for "+identity.site.name);
      this.cancelRequests$.next(true);
      return throwError(error);
    }
    if (error.hasOwnProperty("status") && error.status == 400) {
      this.notifications.notify(cmd + " unexpectedly returned an error message.\n Please report this via the contact us link.\nThe error message was\n" + emsg);
      this.cancelRequests$.next(true);
      return throwError(error);
    }

    if (error.hasOwnProperty("status") && error.status == 504) {
      this.notifications.notify("The Server timed out while retrieving a list of running jobs. Is the application server OK?");
      this.cancelRequests$.next(true);
      return throwError(error);
    }
    if (error.error instanceof ErrorEvent) {
      this.notifications.notify("An error occurred while retrieving the list of jobs. Please reload the page to start polling again.");
      this.cancelRequests$.next(true);
      return throwError(error);
      // continue polling if the network is temporarily disconnected.
      //return of([]);
    } 
  }

  public getJobsError(error,identity: Identity) {
    console.error(error);
    //this.notifications.notify("Unable to retrieve a list of running jobs.\nThis is probably an error on our end.\nPlease report what you were doing via the contact us link");
    this.cancelRequests$.next(true);
    //this.authService.updateAgentContents().subscribe((_) => {return});
  }

}
